import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourcePolicyResponse } from '../../interfaces/resource-policy.interface';
import { PolicyTemplate } from '../../interfaces/policy-template.interface';
import { PolicyClassEntry } from '../../interfaces/policy-class-entry.interface';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root'
})
export class DeletionPolicyService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.baseUrl = this.configService.getApiUrl();
  }

  getResourcePolicy(classId: string): Observable<ResourcePolicyResponse> {
    return this.http.get<ResourcePolicyResponse>(`${this.baseUrl}/v1/classes/resource-policy/${classId}`);
  }

  updateResourcePolicy(classId: string, policy: ResourcePolicyResponse): Observable<ResourcePolicyResponse> {
    return this.http.put<ResourcePolicyResponse>(`${this.baseUrl}/v1/classes/resource-policy/${classId}`, policy);
  }
  /** @deprecated Use PolicyTemplateService.getAll() instead. */
  getAllResourcePolicies(): Observable<PolicyTemplate[]> {
    return this.http.get<PolicyTemplate[]>(`${this.baseUrl}/v1/classes/resource-policy/all`);
  }

  /** @deprecated Use PolicyTemplateService.getById() instead. */
  getResourcePolicyById(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/v1/classes/resource-policy/id/${id}`);
  }

  /** @deprecated Use PolicyTemplateService.create() instead. */
  createResourcePolicy(req: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(req);
    return this.http.post(`${this.baseUrl}/v1/classes/create-resource-policy`, body, { headers });
  }

  /** @deprecated Use PolicyTemplateService.getByType() instead. */
  getResourcePoliciesByType(resourceType: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/v1/classes/resource-policy/type/${resourceType}`);
  }

  setQuotaLimitAndResourcePolicy(request:any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(request);
    return this.http.put<any>(`${this.baseUrl}/v1/classes/set-quota-limit-and-resource-policy`, body, { headers });
  }

  /**
   * Returns the list of classes that reference a given policy template.
   * Backend endpoint: GET /api/v1/classes/resource-policy/{policyId}/classes
   */
  getClassesByPolicy(policyId: string): Observable<PolicyClassEntry[]> {
    return this.http.get<PolicyClassEntry[]>(`${this.baseUrl}/v1/classes/resource-policy/${policyId}/classes`);
  }
}
